import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  sectionMargins,
  standardColours,
} from '../styles';
import { Container, Heading, HtmlContent } from './ui';

const StyledIconContentBlocks = styled.section`
  ${sectionMargins('45px', '90px')};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledItems = styled.div`
  display: grid;
  gap: 30px;
  margin-top: 40px;

  ${minBreakpointQuery.tiny`
    margin-top: 50px;
  `}

  ${minBreakpointQuery.small`
    gap: 35px;
    margin-top: 60px;
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.medium`
    column-gap: 40px;
    row-gap: 50px;
    margin-top: 70px;
  `} 
  
  ${minBreakpointQuery.mlarge`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${minBreakpointQuery.large`
    column-gap: 45px;
    row-gap: 55px;
    margin-top: 80px;
  `} 

  ${minBreakpointQuery.xxlarge`
    column-gap: 50px;
    row-gap: 60px;
    margin-top: 90px;
  `};
`;

const StyledItem = styled.article`
  background-color: ${standardColours.white};
  padding: 30px;
  border-radius: 40px;
  position: relative;

  ${minBreakpointQuery.small`
    padding: 35px;
  `}

  ${minBreakpointQuery.medium`
    padding: 40px;
  `} 

  ${minBreakpointQuery.large`
    padding: 45px;
  `} 

  ${minBreakpointQuery.xxlarge`
    padding: 50px;
  `};
`;

const StyledItemHeading = styled.h3`
  ${fontSize(21)};
  line-height: 1.4;
  font-weight: ${fontWeights.semibold};
  color: ${brandColours.secondary};

  ${minBreakpointQuery.small`
    ${fontSize(23)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(25)};
  `};
`;

const StyledContent = styled(HtmlContent)`
  margin-top: 15px;
`;

const StyledIcon = styled.img`
  width: 100%;
  height: 100%;
  max-width: 50px;
  max-height: 50px;
  background-color: ${brandColours.primary};
  border-radius: 50%;
  padding: 10px;
  position: absolute;
  top: -20px;
  right: -15px;

  ${minBreakpointQuery.tiny`
    max-width: 70px;
    max-height: 70px;
    padding: 15px;
  `}

  ${minBreakpointQuery.large`
    max-width: 90px;
    max-height: 90px;
    padding: 20px;
  `};
`;

const IconContentBlocks = ({ heading, items }) => (
  <StyledIconContentBlocks>
    <Container>
      <StyledHeading>{heading}</StyledHeading>
      <StyledItems>
        {items.map(({ heading, content, icon }, id) => (
          <StyledItem key={id}>
            <StyledItemHeading>{heading}</StyledItemHeading>
            <StyledContent content={content} />
            <StyledIcon src={icon.url} alt={icon.alt} loading="lazy" />
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
  </StyledIconContentBlocks>
);

export default IconContentBlocks;
